(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  
  
  
  
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        const sectionWrapper = this.closest('[data-section-type="product-slider"]');
        const hideSection = () => {
          this.removeAttribute('aria-busy');
          if (sectionWrapper) {
            sectionWrapper.hidden = true;
          } else {
            this.hidden = true;
          }
        };

        fetch(this.dataset.url)
          .then(response => {
            if (!response.ok) {
              throw new Error(`Product recommendations request failed with status ${response.status}`);
            }

            return response.text();
          })
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;

            const recommendations = html.querySelector('[grid-recommendation]');
            const recommendationGrid = this.querySelector('[grid-recommendation]');

            if (!recommendations || !recommendationGrid || !recommendations.innerHTML.trim().length) {
              hideSection();
              return;
            }

            recommendationGrid.innerHTML = recommendations.innerHTML;
            this.removeAttribute('aria-busy');

            requestAnimationFrame(() => {
              const sliderElement = this.querySelector('.productSlider');
              const swiper = sliderElement?.swiper;

              if (!swiper || swiper.destroyed) return;

              swiper.update();
              swiper.slideTo(0, 0);
            });
          })
          .catch(error => {
            console.error('Product recommendations could not be loaded.', error);
            hideSection();
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
